import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delivery-map',
  templateUrl: './delivery-map.component.html',
  styleUrls: ['./delivery-map.component.css']
})
export class DeliveryMapComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
